/*eslint-disable*/
import React, { useState } from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react';

import EditModal from '../modals/editModal';
import BillPaymentDetailsModal from './billPaymentDetailsModal';


function PaymentActionButton(props) {

    const billData = props.data

    const [openModal, setOpenModal] = useState(false)


    const handlePayments = (e) => {
        setOpenModal(true)
    }

    const handleClosePayments = () => {
        setOpenModal(false)
    }

    return (
        <>
            {billData.customerInvoiceNo} <Button onClick={handlePayments} basic className="w3-tiny" circular type="button" icon> <Icon name="info" color="grey" size='small' /></Button>
            <EditModal size="small" open={openModal} onClose={handleClosePayments}>
                <BillPaymentDetailsModal billData={billData} />
            </EditModal>

        </>
    )
}

export default PaymentActionButton
